import { Anchor, Box, Breadcrumbs, Card, Container, SimpleGrid, Stack, Text, ThemeIcon, Title } from '@mantine/core'
import { createFileRoute, Link } from '@tanstack/react-router'
import {
  LuAnchor,
  LuChartBar,
  LuClipboardList,
  LuCreditCard,
  LuFileText,
  LuMap,
  LuMessageCircle,
  LuPackage,
  LuUsers,
} from 'react-icons/lu'

export const Route = createFileRoute('/features')({
  component: FeaturesPage,
})

const FEATURES = [
  {
    icon: LuClipboardList,
    title: 'Booking Multi-Channel',
    desc: 'Walk-in, phone, email, radio, agent — semua channel dalam satu inbox dengan tracking.',
  },
  {
    icon: LuMap,
    title: 'Berth Map Real-Time',
    desc: 'Peta marina interactive, status per-berth, drag-drop assign, overlap detection.',
  },
  {
    icon: LuCreditCard,
    title: 'Billing Indonesia',
    desc: 'Quote → Invoice → Payment dengan PPN 11%, QRIS, Midtrans, Xendit integration.',
  },
  {
    icon: LuFileText,
    title: 'Contracts',
    desc: '5-step wizard untuk kontrak sewa bulanan/tahunan dengan documents & signatures.',
  },
  {
    icon: LuUsers,
    title: 'CRM Pelanggan',
    desc: 'Customer database lengkap dengan kategori Transit/Owner/Renter/Member/Guest.',
  },
  {
    icon: LuAnchor,
    title: 'Timeline Calendar',
    desc: 'Visualisasi booking berth × tanggal, drag untuk reschedule, filter by LOA/pontoon.',
  },
  {
    icon: LuPackage,
    title: 'Inventory',
    desc: 'Stok peralatan marina dengan threshold GOOD/LOW/OUT dan movement tracking.',
  },
  { icon: LuMessageCircle, title: 'Live Chat Internal', desc: 'Komunikasi staff ↔ customer via WebSocket realtime.' },
  {
    icon: LuChartBar,
    title: 'Analytics Dashboard',
    desc: 'Occupancy trend, revenue charts, top customers, frequent visitors.',
  },
]

function FeaturesPage() {
  return (
    <Box style={{ minHeight: '100vh' }}>
      <Container size="xl" py="xl">
        <Breadcrumbs mb="lg">
          <Anchor component={Link} to="/" c="dimmed">
            Home
          </Anchor>
          <span>Fitur</span>
        </Breadcrumbs>
        <Stack gap="xs" mb="xl">
          <Title order={1}>Fitur Lengkap</Title>
          <Text c="dimmed" size="lg">
            9 modul utama untuk mengelola marina modern end-to-end.
          </Text>
        </Stack>

        <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }}>
          {FEATURES.map((f) => (
            <Card key={f.title} padding="lg" radius="md">
              <ThemeIcon variant="light" color="laut" size="xl" radius="md" mb="md">
                <f.icon size={24} />
              </ThemeIcon>
              <Text fw={700} size="lg" mb="xs">
                {f.title}
              </Text>
              <Text size="sm" c="dimmed">
                {f.desc}
              </Text>
            </Card>
          ))}
        </SimpleGrid>
      </Container>
    </Box>
  )
}
